import React, { useEffect } from 'react';

interface NumberPickerProps {
  value: number | null;
  onChange: (value: number) => void;
  min: number;
  max: number;
  unit: string;
  unitPlural: string;
}

const btnStyle: React.CSSProperties = {
  width: 48,
  height: 48,
  borderRadius: '50%',
  background: 'rgba(250,253,251,0.08)',
  border: '1px solid rgba(250,253,251,0.16)',
  color: 'var(--color-text-light)',
  fontSize: 24,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s ease',
  fontFamily: "'Figtree', sans-serif",
};

const NumberPicker: React.FC<NumberPickerProps> = ({ value, onChange, min, max, unit, unitPlural }) => {
  const current = value ?? min;

  // Emit default value on mount so Continue is enabled immediately
  useEffect(() => {
    if (value === null || value === undefined) {
      onChange(min);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
        <button
          type="button"
          style={{ ...btnStyle, opacity: current <= min ? 0.3 : 1, cursor: current <= min ? 'not-allowed' : 'pointer' }}
          onClick={() => current > min && onChange(current - 1)}
          disabled={current <= min}
        >
          −
        </button>
        <span style={{
          fontFamily: "'Figtree', sans-serif",
          fontSize: 48,
          fontWeight: 400,
          color: 'var(--color-text-light)',
          minWidth: 80,
          textAlign: 'center',
        }}>
          {current}
        </span>
        <button
          type="button"
          style={{ ...btnStyle, opacity: current >= max ? 0.3 : 1, cursor: current >= max ? 'not-allowed' : 'pointer' }}
          onClick={() => current < max && onChange(current + 1)}
          disabled={current >= max}
        >
          +
        </button>
      </div>
      <span style={{
        fontFamily: "'Figtree', sans-serif",
        fontSize: 16,
        color: 'rgba(250,253,251,0.5)',
      }}>
        {current === 1 ? unit : unitPlural}
      </span>
    </div>
  );
};

export default NumberPicker;
